import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import MentionableInput from '@components/common/mentions/MentionableInput';

const NewAnnotation = ({ mentionableUsers, onSubmit, setMentionableUsers }) => {
  const [value, setValue] = useState("");
  const [mentionedUsers, setMentionedUsers] = useState([]);
  const annotationTextarea = useRef();

  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit(value, mentionedUsers);
  };

  return (
    <div>
      <h4>{t('Leave an annotation')}</h4>
      <MentionableInput
        content={value}
        focusOnMount
        providedData={mentionableUsers}
        inputRef={annotationTextarea}
        onChange={(content, ids) => { setValue(content); setMentionedUsers(ids); }}
        onSubmit={handleSubmit}
        setParentMentionableUsers={setMentionableUsers}
      />
      <button
        type="button"
        className="button primary sm new-annotation-button"
        disabled={!value}
        onClick={handleSubmit}
      >
        {t('Post')}
      </button>
    </div>
  );
};

NewAnnotation.propTypes = {
  mentionableUsers: PropTypes.arrayOf(PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    email: PropTypes.string,
  })),
  onSubmit: PropTypes.func,
  setMentionableUsers: PropTypes.func.isRequired,
};

NewAnnotation.defaultProps = {
  mentionableUsers: null,
  onSubmit: () => {},
};

export default NewAnnotation;
